import { Alert, Box, Button, Divider, Link, Typography } from '@mui/material';
import { t } from 'i18next';
import { RequestData } from '../../../useRequestData';
import './FinalStep.css';
import { closeSnackbar } from '../../../../SnackbarProvider/snackbarSlice';
import { useAppDispatch } from '../../../../../shared/redux/store';
import { useEffect } from 'react';
import { useAppContext } from '../../../../App.Context';

interface FinalStepProps {
  onReset: () => void;
  requestData: RequestData;
  redirectTo: (params: string) => void;
}
const FinalStep: React.FC<FinalStepProps> = ({ onReset, requestData, redirectTo }) => {
  const { createdRequest, student, resetRequest } = requestData;
  const querySearch = `?documentType=${student?.document_type}&documentNumber=${student?.document_number}&caseNumber=${createdRequest?.case_number}`;
  const { setRequestType } = useAppContext();

  const dispatch = useAppDispatch();
  const handleReset = () => {
    resetRequest();
    onReset();
    setRequestType('undefined')
  };
  const handleClickLink = () => {
    redirectTo(querySearch);
  };

  useEffect(() => {
    return () => {
      dispatch(closeSnackbar())
    }
  }, []);

  return (
    <Box
      sx={{
        padding: '24px 0px',
        display: 'grid',
        margin: 'auto',
        height: '100%',
        flexDirection: 'column',
        justifyContent: 'center'
      }}
    >
      <Box
        className="final-step-box"
        margin="auto"
        display={'grid'}
        justifyItems="space-between"
        minHeight={'400px'}
        maxWidth="600px"
        padding="24px"
        borderRadius={'16px'}
      >
        <Typography className="final-step-box__info" variant="h5" align="center">
          <>{t('finalStepInfo')}</>
        </Typography>
        <br />

        <Alert severity="success" data-testid={'success-message'}>
          <Box className="final-step-box__success-text" sx={{ align: 'center' }}>
            <>{t('successMessageOnRequestSended')}</> <br />
            <Link onClick={handleClickLink}  data-testid={'link-to-request-search'}>
              <>{t('equivalencyRequestLinkLabel')}</>
            </Link>
          </Box>
        </Alert>
        <br></br>
        <Divider></Divider>
        <br></br>
        <Typography align="center">{`${t('thisIsYourTrackingCode')} ${createdRequest?.case_number}`}</Typography>
      </Box>
      <Box margin="auto" padding={2}>
        <Button color="primary" id="load-another-request" data-testid="load-another-request" variant="contained" fullWidth={false} onClick={handleReset}>
          <>{t('makeRequest')}</>
        </Button>
      </Box>
    </Box>
  );
};
export default FinalStep;
